// Sub-item UI types and helpers for the breakdown editor.
// Calculator logic lives in @jobos/shared/utils/breakdownCalculator.

import type { SubItemCategory, SubItemTypeMetaMap } from '@jobos/shared';
import { isQtyRateCategory, getSubItemLabel as sharedGetSubItemLabel, BUILT_IN_KEYS, DEFAULT_SUB_ITEM_CATEGORIES, buildSubItemTypeMetaMap } from '@jobos/shared';

// Re-export for convenience (consumed by local UI helpers)
export { isQtyRateCategory, BUILT_IN_KEYS };

export type SubItemType = string;
export type QtyRateSubItemType = string;

// Default categories for when API data hasn't loaded yet
const DEFAULT_CATEGORIES: SubItemCategory[] = DEFAULT_SUB_ITEM_CATEGORIES.map((c, i) => ({ ...c, id: `default-${i}` }));
const DEFAULT_TYPE_META: SubItemTypeMetaMap = buildSubItemTypeMetaMap(DEFAULT_CATEGORIES, []);

export function isQtyRateType(type: string, typeMeta?: SubItemTypeMetaMap): boolean {
  const meta = typeMeta ?? DEFAULT_TYPE_META;
  return isQtyRateCategory(type, meta);
}

// Lean form-state types (no DB fields like lineItemId, sortOrder, createdAt)

export interface LaborSubItemForm {
  id: string;
  type: string;
  hours: number;
  rate: number;
  rateType?: 'hourly' | 'daily';
  unitKey?: string;
  note?: string;
  markupRate?: number;
}

export interface DirectSubItemForm {
  id: string;
  type: string;
  amount: number;
  note?: string;
  markupRate?: number;
}

export type SubItemForm = LaborSubItemForm | DirectSubItemForm;

// UI helpers

export function getSubItemLabel(type: string, typeMeta?: SubItemTypeMetaMap): string {
  const meta = typeMeta ?? DEFAULT_TYPE_META;
  return sharedGetSubItemLabel(type, meta);
}

export function getSubItemTypeOptions(categories?: SubItemCategory[]): Array<{ value: string; label: string }> {
  const cats = categories ?? DEFAULT_CATEGORIES;
  return cats.map((c) => ({ value: c.key, label: c.label }));
}

export function createSubItem(type: string, typeMeta?: SubItemTypeMetaMap): SubItemForm {
  const id = crypto.randomUUID();
  if (isQtyRateType(type, typeMeta)) {
    return { id, type, hours: 0, rate: 0, note: '' };
  }
  return { id, type, amount: 0, note: '' };
}
